<template>
    <div>
        <div class="company-info-card">
            <b-avatar class="company-info-card--avatar avatar" :src="(logoUrl) ? logoUrl : ''" :text="customerDetails.name[0]" size="8rem" />
            <div class="company-info-card--contentwrap">
                <div class="company-info-card--companyname">
                <h2>{{ customerDetails.name }}</h2>
                <div class="sector">{{ sectorText }}</div>
                </div>
                <div class="company-info-card--content">
                <div class="content-col">
                    <div>{{ getDetailText(customerDetails.created_by.display_name) }}</div>
                    <div>{{ getDetailText(customerDetails.email) }}</div>
                    <div>{{ getDetailText(customerDetails.phone_number) }}</div>
                </div>
                <div class="content-col">
                    <div>{{ getDetailText(customerDetails.address) }}</div>
                    <div>Kvk: {{ getDetailText(customerDetails.kvk) }}</div>
                    <div>Vat: {{ getDetailText(customerDetails.btw) }}</div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GekkoButton from '@/components/GekkoButton';
import CompanyService from '@/store/services/company.service.js';

export default {
    name: "CustomerOverview", 
    components: { GekkoButton },
    props: {
        customerDetails: {
            type: Object,
            default: () => {}
        },
        accountantConnection: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            sectorOptions: [],
            logoUrl: null
        }
    },
    computed: {
        sectorText() {
            if (!this.customerDetails.sector) {
                return "-";
            }
            if (this.sectorOptions.length) {
                return this.sectorOptions.find(sector => sector.key === this.customerDetails.sector).value;
            } else {
                return this.customerDetails.sector;
            }
        }
    },
    created () {
        CompanyService.getSectors().then((response) => {
            this.sectorOptions = response.data;
        });
        if (this.customerDetails.id) {
            CompanyService.getCustomerCompany(this.customerDetails.id).then((response) => {
                this.logoUrl = response.data.logo;
            });
        }
    },
    methods: {
        getDetailText(detailText) {
            if (!detailText) {
                return "-";
            } else {
                return detailText;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.company-info-card {
    display: flex;
    flex-direction: row;
    border-radius: 12px;
    padding: 1rem;
    border: 1px solid $colorBorderDash;
    font-size: 16px;
    background: #f9f9f9;
    &--contentwrap {
        padding-left: 1rem;
        display: flex;
        flex-direction: column;
    }
    &--companyname {
        display: flex;
        flex-direction: column;
        h2 {
        margin: 0;
        font-size: 24px;
        line-height: 1;
        }
        .sector {
        color: #adadad;
        }
        margin-bottom: 5px;
    }
    &--content {
        display: flex;
        line-height: 1.4;
        .content-col {
        display: flex;
        flex-direction: column;
        &:last-child {
            padding-left: 1rem;
        }
        }
    }
}
</style>